<div class="ai-audio-processing-page">
  <header class="project-header">
    <p class="eyebrow">Portfolio :: AI-Based Audio Processing</p>
    <div class="hero-layout">
      <div>
        <h1>AI-Based Audio Processing</h1>
        <div class="meta-badges">
          <span>Android</span>
          <span>AI</span>
          <span>Audio processing</span>
          <span>Offline-first</span>
        </div>
      </div>
    </div>
  </header>

  <div class="content-grid">
    <section class="project-copy">
      <p>
        AI-Based Audio Processing is a meeting assistant concept designed to capture conversations,
        turn them into searchable transcripts, and transform them into useful meeting notes.
      </p>

      <ul class="feature-list">
        <li>Record meetings and transcribe audio in continuous segments.</li>
        <li>Keep audio chunks safe while offline and synchronize them when connectivity returns.</li>
        <li>Chat with the transcript during and after a meeting.</li>
        <li>Generate concise, structured summaries automatically.</li>
        <li>Connect meeting context with Google Calendar.</li>
      </ul>

      <a class="project-link" target="_blank" rel="noopener"
         href="https://github.com/jawegielewski/AI-Based-Audio-Processing">
        View on GitHub
      </a>
    </section>

    <aside class="project-visual screenshot-gallery">
      <img class="phone-shot" src="../../../../assets/images/ai_s1.jpg"
           alt="AI Based Audio Processing screenshot 1">
      <img class="phone-shot" src="../../../../assets/images/ai_s2.jpg"
           alt="AI Based Audio Processing screenshot 2">
      <img class="phone-shot" src="../../../../assets/images/ai_s3.jpg"
           alt="AI Based Audio Processing screenshot 3">
      <img class="phone-shot" src="../../../../assets/images/ai_s4.jpg"
           alt="AI Based Audio Processing screenshot 4">
      <img class="phone-shot" src="../../../../assets/images/ai_s5.jpg"
           alt="AI Based Audio Processing screenshot 5">
    </aside>
  </div>
</div>
